import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import {format} from 'date-fns';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {yupResolver} from '@hookform/resolvers';
import SelectList from '../../components/FormFields/Select';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import {getAllRevisionTypes} from '../../services/revisionTypes/revisionTypes';
import SelectInfinite from "../../components/FormFields/SelectInfinite";
import {FINDING_STATUS, PROGRESS_STATUS, RISK_LEVEL} from "../revisions/const";
import {getAllRevisionScopesWithMultipleRevisionTypes} from "../../services/revisionScope/revisionScope";
import {useUserContext} from "../../contexts/UserContext";
import roles from "../../utils/roles";
import {appModules} from '../../utils/const';

const RevisionReports = () => {

    const lang = getLanguage();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const user = useUserContext();


    const [revisionsTypes, setRevisionsTypes] = useState([]);
    const [revisionsScopes, setRevisionsScopes] = useState([]);

    const schema = yup.object().shape({findingStatus: yup
            .object()
            .required(t('message.fieldRequired'))
    });

    const methods = useForm({
        resolver: yupResolver(schema),
    });
    const {watch,errors,formState,getValues,setError,clearErrors,setValue} = methods;

    let validFrom = watch('startDate');
    let validTo = watch('endDate');
    let  deadlineFrom= watch("deadlineFrom");
    let deadlineTo = watch("deadlineTo");
    const revisionModeValue = watch('revisionMode');
    const revisionQuarterValue = watch('revisionQuarter');
    const revisionTypeValue = watch('revisionTypeId');
    const revisionScopeValue = watch('revisionScopeId');
    const userResponsibleId = watch("userResponsibleId");
    const department = watch("department");
    const usersInvolved = watch("usersInvolved");
    const riskLevel = watch("riskLevel");
    const findingStatus = watch("findingStatus");
    const progressStatus = watch("progressStatus");
    const referenceId = watch("referenceId");
    const findingName = watch("findingName");





    const fetchRevisionsTypes = async () => {
        try {
            const {data} = await getAllRevisionTypes();
            setRevisionsTypes(data);
            return data;
        } catch (e) {}
    };
    const fetchRevisionsScopes = async () => {
        try {
            const {data} = await getAllRevisionScopesWithMultipleRevisionTypes(revisionTypeValue);
            setRevisionsScopes(data);
            return data;
        } catch (e) {}
    };

    const higherRoles = [
        roles.role_super_admin,
        roles.role_admin,
        roles.role_head_of_internal_audit,
        roles.role_internal_auditor
    ];

    const shouldShow = user.authorities.some(role => higherRoles.includes(role));

    useEffect(() => {
        if(shouldShow) {
            fetchRevisionsTypes().then((r) => {
                let revisionsTypes = [];
                r.forEach((item) => {
                    revisionsTypes.push(
                        lang === 'eng'
                            ? {value: item.id, label: item.nameEn}
                            : {
                                value: item.id,
                                label: item.name,
                            }
                    );
                });

                setRevisionsTypes(revisionsTypes);
            });
        }
    }, []);


    const [revisionTypesToIgnore,setRevisionTypesToIgnore]=useState()

    useEffect(() => {
        if(shouldShow) {
            fetchRevisionsScopes().then((r) => {
                let revisionsScopes = [];


                r.forEach((item) => {

                    revisionsScopes.push(
                        lang === 'eng'
                            ? {value: item.id, label: item.nameEn, revisionTypeId: item.revisionTypeId}
                            : {
                                value: item.id,
                                label: item.name,
                                revisionTypeId: item.revisionTypeId
                            }
                    );

                });

                setRevisionsScopes(revisionsScopes);

                let scopesToAdd = []
                let scopesToRemove = []

                for (let i = 0; i < revisionsScopes.length; i++) {
                    if (!revisionTypesToIgnore?.has(revisionsScopes[i]?.revisionTypeId)) {
                        scopesToAdd.push(revisionsScopes[i])
                    }
                }

                for (let i = 0; i < revisionTypeValue?.length; i++) {
                    scopesToRemove.push(revisionTypeValue[i].value)
                }

                let final = revisionScopeValue ? [...new Set([...revisionScopeValue, ...scopesToAdd])] : scopesToAdd

                for (let i = 0; i < final?.length; i++) {
                    if (!scopesToRemove.includes(final[i].revisionTypeId)) {
                        final.splice(i, 1)
                        i--
                    }

                }


                setValue("revisionScopeId", final);

            });
        }
    }, [revisionTypeValue]);




    useEffect(() => {

        let ignoreTypes = new Set()

        for (let i = 0; i <revisionScopeValue?.length ; i++) {
            ignoreTypes.add(revisionScopeValue[i].revisionTypeId)
        }



        setRevisionTypesToIgnore(ignoreTypes)
    }, [revisionScopeValue]);






    useEffect(() => {
        if (revisionTypeValue && !revisionScopeValue){
            setError("revisionScopeId",{ type: 'custom', message: t('message.fieldRequired') })
        }else{
            clearErrors("revisionScopeId")
        }

        if(!revisionTypeValue){
            setValue("revisionScopeId",null)
        }



    }, [revisionTypeValue,revisionScopeValue]);



    const revisionModeList = [
        {value: 'REGULAR', label: getLanguage() === 'mne' ? 'REDOVNA' : 'REGULAR'},
        {value: 'EXTRAORDINARY', label: getLanguage() === 'mne' ? 'VANDREDNA' : 'EXTRAORDINARY'},
    ];
    const revisionQuarterList = [
        {value: 'I', label: 'I'},
        {value: 'II', label: 'II'},
        {value: 'III', label: 'III'},
        {value: 'IV', label: 'IV'},
    ];

    const progressOptions=getLanguage() === "eng"
        ? [
            {
                label: PROGRESS_STATUS.SATISFACTORY.en,
                value: PROGRESS_STATUS.SATISFACTORY.value,
            },
            {
                label: PROGRESS_STATUS.MODERATE.en,
                value: PROGRESS_STATUS.MODERATE.value,
            },
            {
                label: PROGRESS_STATUS.CRITICAL.en,
                value: PROGRESS_STATUS.CRITICAL.value,
            },

        ]
        : [
            {
                label: PROGRESS_STATUS.SATISFACTORY.mne,
                value: PROGRESS_STATUS.SATISFACTORY.value,
            },
            {
                label: PROGRESS_STATUS.MODERATE.mne,
                value: PROGRESS_STATUS.MODERATE.value,
            },
            {
                label: PROGRESS_STATUS.CRITICAL.mne,
                value: PROGRESS_STATUS.CRITICAL.value,
            },

        ]

    const statusOptions= getLanguage() === "eng"
        ? [
            {
                label: FINDING_STATUS.COMPLETED.en,
                value: FINDING_STATUS.COMPLETED.value,
            },
            {
                label: FINDING_STATUS.INCOMPLETE.en,
                value: FINDING_STATUS.INCOMPLETE.value,
            },
            {
                label: FINDING_STATUS.PARTIALLY_COMPLETED.en,
                value: FINDING_STATUS.PARTIALLY_COMPLETED.value,
            },
            {
                label: FINDING_STATUS.CONTINUOUS.en,
                value: FINDING_STATUS.CONTINUOUS.value,
            },
            {
                label: FINDING_STATUS.IN_PROGRESS.en,
                value: FINDING_STATUS.IN_PROGRESS.value,
            },
            {
                label: FINDING_STATUS.ABORTED.en,
                value: FINDING_STATUS.ABORTED.value,
            },
        ]
        : [
            {
                label: FINDING_STATUS.COMPLETED.mne,
                value: FINDING_STATUS.COMPLETED.value,
            },
            {
                label: FINDING_STATUS.INCOMPLETE.mne,
                value: FINDING_STATUS.INCOMPLETE.value,
            },
            {
                label: FINDING_STATUS.PARTIALLY_COMPLETED.mne,
                value: FINDING_STATUS.PARTIALLY_COMPLETED.value,
            },
            {
                label: FINDING_STATUS.CONTINUOUS.mne,
                value: FINDING_STATUS.CONTINUOUS.value,
            },
            {
                label: FINDING_STATUS.IN_PROGRESS.mne,
                value: FINDING_STATUS.IN_PROGRESS.value,
            },
            {
                label: FINDING_STATUS.ABORTED.mne,
                value: FINDING_STATUS.ABORTED.value,
            },
        ]

    const riskOptions =getLanguage() === "eng"
        ? [
            {
                label: RISK_LEVEL.LOW.en,
                value: RISK_LEVEL.LOW.value,
            },
            {
                label: RISK_LEVEL.MEDIUM.en,
                value: RISK_LEVEL.MEDIUM.value,
            },
            {
                label: RISK_LEVEL.HIGH.en,
                value: RISK_LEVEL.HIGH.value,
            },
        {
          label: RISK_LEVEL.VERY_HIGH.en,
          value: RISK_LEVEL.VERY_HIGH.value,
        }
        ]
        : [
            {
                label: RISK_LEVEL.LOW.mne,
                value: RISK_LEVEL.LOW.value,
            },
            {
                label: RISK_LEVEL.MEDIUM.mne,
                value: RISK_LEVEL.MEDIUM.value,
            },
            {
                label: RISK_LEVEL.HIGH.mne,
                value: RISK_LEVEL.HIGH.value,
            },
        {
          label: RISK_LEVEL.VERY_HIGH.mne,
          value: RISK_LEVEL.VERY_HIGH.value,
        }
        ]



    const returnMultiSelectString=(options,apiParamAddon)=>{
        let string=''

        for (let i = 0; i < options.length; i++) {
            if(i<options.length-1){
                string+=apiParamAddon + "=" +options[i].value +"&"
            }else{
                string+=apiParamAddon + "=" +options[i].value
            }
        }
        return string
    }

    return (
        <div className="revisions-reports-page content">
            <FormProvider {...methods}>
                <div className="report-form-container" key={window.location.pathname}>
                    <div className="row  ml-0 mr-0">
                        {shouldShow &&  <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t('revisions.revisionType')}
                                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
                            </label>
                            <SelectList
                                name="revisionTypeId"
                                options={revisionsTypes}
                                placeholder={t('common.select')}
                                isMulti
                            />
                        </div>}
                        {shouldShow && <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t('revisions.revisionScope')}
                            </label>
                            <SelectList
                                name="revisionScopeId"
                                options={revisionsScopes}
                                placeholder={t('common.select')}
                                isDisabled={!revisionTypeValue}
                                isMulti
                            />
                        </div>}
                        <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t('revisions.mode')}
                                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
                            </label>
                            <SelectList
                                name="revisionMode"
                                options={revisionModeList}
                                placeholder={t('common.select')}
                            />
                        </div>
                        <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t('revisions.quarter')}
                                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
                            </label>
                            <SelectList
                                name="revisionQuarter"
                                options={revisionQuarterList}
                                placeholder={t('common.select')}
                                isMulti
                            />
                        </div>
                        <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="startDate">
                                {t('revisions.dateOfIssueFrom')}
                                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
                            </label>
                            <InputDate
                                name="startDate"
                                maxDate={validTo}
                                className={`date-height form-control`}
                                isClearable={true}
                                placeholderText={t('revisions.dateOfIssueFrom')}
                            />
                        </div>
                        <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="endDate">
                                {t('revisions.dateOfIssueTo')}
                                <span className="optional register line-height">
                  {t('common.optional')}
                </span>
                            </label>
                            <InputDate
                                name="endDate"
                                minDate={validFrom}
                                className={`date-height form-control`}
                                isClearable={true}
                                placeholderText={t('revisions.dateOfIssueTo')}
                            />
                        </div>
                        <div  className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t("revisions.findingStatus")}
                                <span className="optional register line-height">
                  {t("common.optional")}
                </span>
                            </label>
                            <SelectList
                                name="findingStatus"
                                className="select"
                                placeholder={t('common.select')}
                                options={
                                    statusOptions
                                }
                                isClearable
                                isMulti
                            />
                        </div>
                        {shouldShow && <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t("incurred-risk.responsibleUser")}
                                <span className="optional register line-height">
                                 {t("common.optional")}
                               </span>
                            </label>
                            <SelectInfinite
                                api={`/users/audit-responsible?sort=firstName`}
                                name="userResponsibleId"
                                className={errors.userResponsibleIdValidation && "error-field"}
                                placeholder={t('common.select')}
                                queryKeys={"firstName.contains"}
                                labelKey={"fullName"}
                                isMulti
                            />
                        </div>}
                        {shouldShow && <div  className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t("revisions.participants")}
                                <span className="optional register line-height">
                  {t("common.optional")}
                </span>
                            </label>
                            <SelectInfinite
                                api={`/users/audit-responsible?sort=firstName`}
                                name="usersInvolved"
                                className={errors.userResponsibleIdValidation && "error-field"}
                                placeholder={t('common.select')}
                                queryKeys={"firstName.contains"}
                                labelKey={"fullName"}
                                isMulti
                            />
                        </div>}
                        {shouldShow && <div style={{ minWidth: "250px" }} className=" pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t("departments.department")}
                                <span className="optional register line-height">
                  {t("common.optional")}
                </span>
                            </label>
                            <SelectInfinite
                              api={`/departments?appModuleId.equals=${appModules?.revisionModule}&active.equals=true`}
                              name="department"
                                isDepartmentSelect={true}
                                labelKey={lang === "mne" ? "name" : "nameEn"}
                                className="department"
                                placeholder={t('common.select')}
                                isMulti
                            />
                        </div>}
                        <div  className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t("revisions.progressStatus")}
                                <span className="optional register line-height">
                  {t("common.optional")}
                </span>
                            </label>
                            <SelectList
                                name="progressStatus"
                                className="select"
                                placeholder={t('common.select')}
                                options={progressOptions}
                                isMulti
                            />
                        </div>
                        <div  className="form-group pr-5">
                            <label className="label w-100" htmlFor="riskType">
                                {t("revisions.riskLevel")}
                                <span className="optional register line-height">
                  {t("common.optional")}
                </span>
                            </label>
                            <SelectList
                                name="riskLevel"
                                className="select"
                                placeholder={t('common.select')}
                                options={
                                    riskOptions
                                }
                                isClearable
                                isMulti
                            />
                        </div>
                        <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="endDate">
                                {t("revisions.deadlineFrom")}
                                <span className="optional register line-height">
                  {t("common.optional")}
                </span>
                            </label>
                            <InputDate
                                name="deadlineFrom"
                                className={`date-height form-control`}
                                isClearable={true}
                                placeholderText={t("revisions.deadlineFrom")}
                                maxDate={deadlineTo}
                            />
                        </div>
                        <div className="form-group pr-5">
                            <label className="label w-100" htmlFor="startDate">
                                {t("revisions.deadlineTo")}
                                <span className="optional register line-height">
                  {t("common.optional")}
                </span>
                            </label>
                            <InputDate
                                name="deadlineTo"
                                className={`date-height form-control`}
                                isClearable={true}
                                placeholderText={t("revisions.deadlineTo")}
                                minDate={deadlineFrom}
                            />
                        </div>





                        {/*<div className="form-group pr-5">*/}
                        {/*  <label className="label w-100" htmlFor="startDate">*/}
                        {/*    {t('revisions.referenceId')}*/}
                        {/*    <span className="optional register line-height">*/}
                        {/*      {t('common.optional')}*/}
                        {/*    </span>*/}
                        {/*  </label>*/}
                        {/*    <InputText*/}
                        {/*        type="text"*/}
                        {/*        name="referenceId"*/}
                        {/*        placeholder={t('revisions.placeholder.referenceId')}*/}
                        {/*    />*/}
                        {/*</div>*/}
                        {/*<div className="form-group pr-5">*/}
                        {/*  <label className="label w-100" htmlFor="startDate">*/}
                        {/*    {t('revisions.findingName')}*/}
                        {/*    <span className="optional register line-height">*/}
                        {/*      {t('common.optional')}*/}
                        {/*    </span>*/}
                        {/*  </label>*/}
                        {/*  <InputText*/}
                        {/*      type="text"*/}
                        {/*      name="findingName"*/}
                        {/*      placeholder={t('revisions.placeholder.findingName')}*/}
                        {/*  />*/}
                        {/*</div>*/}




                        <DownloadBtn
                            api={'reports/findings'}
                            isDisabled={Object.keys(errors).length !== 0}
                            paramsLength={14}
                            setIsSubmitted={(e) => setIsSubmitted(e)}
                            documentName={`PDF`}
                            disableCheckingIfAllFilled={true}
                            apiParameters={{
                                department:
                                    department !== null &&
                                    department !== undefined
                                        ? returnMultiSelectString(watch('department'),"departments")
                                        : "",
                                revisionQuarter:
                                    revisionQuarterValue !== null && revisionQuarterValue !== undefined
                                        ? returnMultiSelectString(watch('revisionQuarter'),"quarters")
                                        : '',
                                findingStatus:
                                    findingStatus !== null &&
                                    findingStatus !== undefined
                                        ? returnMultiSelectString(watch('findingStatus'),"findingStatuses")
                                        : "",
                                progressStatus:
                                    progressStatus !== null &&
                                    progressStatus !== undefined
                                        ? returnMultiSelectString(watch('progressStatus'),"progressStatuses")
                                        : "",
                                revisionMode:
                                    revisionModeValue !== null && revisionModeValue !== undefined
                                        ? `revisionMode=${watch('revisionMode').value}`
                                        : '',
                                revisionScope:
                                    revisionScopeValue !== null && revisionScopeValue !== undefined
                                        ? returnMultiSelectString(watch('revisionScopeId'),"revisionScopes")
                                        : '',
                                revisionTypeId:
                                    revisionTypeValue !== null && revisionTypeValue !== undefined
                                        ? returnMultiSelectString(watch('revisionTypeId'),"revisionTypes")
                                        : '',
                                riskLevel:
                                    riskLevel !== null &&
                                    riskLevel !== undefined
                                        ? returnMultiSelectString(watch('riskLevel'),"riskLevels")
                                        : "",
                                userResponsibleId:
                                    userResponsibleId !== null && userResponsibleId !== undefined
                                        ? returnMultiSelectString(watch('userResponsibleId'),"responsiblePersons")
                                        : "",
                                usersInvolved:
                                    usersInvolved !== null && usersInvolved !== undefined
                                        ? returnMultiSelectString(watch('usersInvolved'),"usersInvolved")
                                        : "",
                                startDate:
                                    validFrom !== null && validFrom !== undefined
                                        ? `revisionFrom=${encodeURIComponent(
                                            format(validFrom, 'yyyy-MM-dd')
                                        )}`
                                        : '',
                                endDate:
                                    validTo !== null && validTo !== undefined
                                        ? `revisionTo=${encodeURIComponent(
                                            format(validTo, 'yyyy-MM-dd')
                                        )}`
                                        : '',
                                deadlineFrom:
                                    deadlineFrom !== null && deadlineFrom !== undefined
                                        ? `findingFrom=${encodeURIComponent(
                                            format(deadlineFrom, "yyyy-MM-dd"),
                                        )}`
                                        : "",
                                deadlineTo:
                                    deadlineTo !== null && deadlineTo !== undefined
                                        ? `findingTo=${encodeURIComponent(
                                            format(deadlineTo, "yyyy-MM-dd"),
                                        )}`
                                        : "",
                            }}
                        />
                    </div>
                </div>
            </FormProvider>
        </div>
    );
};

export default RevisionReports;